import createApolloClient, { AUTH_TYPE } from "@covertree/apollo";

export const { client, useApolloNetworkStatus } = createApolloClient(
  AUTH_TYPE.API_KEY
);
